/*
 *  Author: DL
 *  Date: 2020-12-03 15:45:32
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-08 15:00:13
 *  LastEditors: DL
 *  Description: 搜索目的地
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { forwardRef } from 'react';
import { Button, Input, Icon } from 'ui';
import styles from './index.less';

export default forwardRef(function(props, ref) {
    const { onClick, ...inputProps } = props;

    return (
        <div className={styles.wrapper}>
            <Button onClick={onClick}>
                <Icon className="iconBack" />
            </Button>
            <div className={styles.inputWrapper}>
                <Input ref={ref} prefix="iconfdj" {...inputProps} />
            </div>
        </div>
    );
});
